import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  padding: 16px 16px 0;
  width: 100%;

  .title {
    margin-bottom: 16px;
  }

  .score-graph {
    width: 100%;

    &.no-data {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 160px;
      color: ${(props) => props.theme.colors.text};
      opacity: 0.35;
      font-size: 14px;
    }

    &.single-point {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 160px;
      gap: 8px;

      .single-score {
        font-size: 64px;
        font-weight: 700;
        color: ${(props) => props.theme.colors.salmon};
        line-height: 1;
      }

      .single-label {
        font-size: 13px;
        color: ${(props) => props.theme.colors.text};
        opacity: 0.6;
      }
    }
  }
`;

export default { Wrapper };
